import { render, staticRenderFns } from "./DownloadsModal.vue?vue&type=template&id=6769c572&"
import script from "./DownloadsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports